import React from "react";
import './StyledHeading.scss'

enum Structure {
    heading = 'styled_heading'
}
export default function StyledHeading(props: {text: string} & PrivateProjects.Assets.GlobalTypes.StyleableComponent){
    return <h2 className={Structure.heading} style={props.style}>{props.text}</h2>
}